import { AuthProvider } from "../auth";
import { Any } from "../fakeTypes";

export type MixpanelProperties = Record<string, Any>;

export interface IMixpanelClient {
  identify(id: string): void;
  unionPeople(props: MixpanelProperties): void;
  setPeople(props: MixpanelProperties): void;
  setPeopleOnce(props: MixpanelProperties): void;
  registerOnce(properties: MixpanelProperties): void;
  getProperty(propertyName: string): Any;
  trackWalletConnect(
    walletAddress: string,
    isNewUser: boolean,
    identityProvider: AuthProvider,
    appName: string | undefined,
  ): void;
  reset(): void;
}

export const MIXPANEL_PLATFORM = {
  WEB: "web",
  TELEGRAM: "telegram",
} as const;

export type MixpanelPlatformType = (typeof MIXPANEL_PLATFORM)[keyof typeof MIXPANEL_PLATFORM];
